// extracted by mini-css-extract-plugin
module.exports = {"container":"SustainabilityQuiz_container__tVY9i"};